(function () {
  'use strict';

  const HERO_FINDS = [
    { item: 'Keys',           where: 'Couch · 12 feet away' },
    { item: 'Wallet',         where: 'Jacket pocket · upstairs' },
    { item: 'Backpack',       where: 'Mudroom · home' },
    { item: 'Luggage',        where: 'Terminal C · LaGuardia' },
    { item: 'Bike',           where: 'Bike rack · 8th & Market' },
    { item: 'Laptop bag',     where: 'Office · 2 floors up' },
    { item: "Kid's backpack", where: 'Bus stop · arriving 3:14 PM' },
    { item: 'Remote control', where: 'Between couch cushions' },
  ];

  const STATUS_GLYPHS = {
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M8 12l3 3 5-6"/></svg>',
    bell:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 8a6 6 0 1112 0c0 6 3 7 3 7H3s3-1 3-7"/><path d="M10 21a2 2 0 004 0"/></svg>',
    siri:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M5 11v2M9 8v8M13 6v12M17 9v6M21 11v2"/></svg>',
    pin:   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 21s-7-7-7-12a7 7 0 0114 0c0 5-7 12-7 12z"/><circle cx="12" cy="9" r="2.6"/></svg>',
  };

  const HERO_STATUSES = [
    { label: 'Status',  text: 'Connected · Ringing',   icon: 'check' },
    { label: 'Alert',   text: 'Left behind · Café',    icon: 'bell'  },
    { label: 'Siri',    text: '"Hey Siri, find keys"', icon: 'siri'  },
    { label: 'Located', text: 'Pin dropped on map',    icon: 'pin'   },
  ];

  function startNotifCycler(root) {
    const track = root.querySelector('.hero-notif-track');
    if (!track) return;
    const itemEl  = track.querySelector('[data-tm-notif-item]');
    const whereEl = track.querySelector('[data-tm-notif-where]');
    let i = 0;
    setInterval(function () {
      i = (i + 1) % HERO_FINDS.length;
      const f = HERO_FINDS[i];
      track.style.animation = 'none';
      void track.offsetWidth;
      track.style.animation = '';
      itemEl.textContent  = f.item + ' located';
      whereEl.textContent = f.where;
    }, 2400);
  }

  function startStatusCycler(root) {
    const txt   = root.querySelector('.hero-tag .txt');
    const blob  = root.querySelector('.hero-tag .blob');
    if (!txt || !blob) return;
    const labelEl = txt.querySelector('small');
    const textEl  = txt.querySelector('strong');
    let i = 0;
    setInterval(function () {
      i = (i + 1) % HERO_STATUSES.length;
      const s = HERO_STATUSES[i];
      txt.style.animation = 'none';
      void txt.offsetWidth;
      txt.style.animation = '';
      labelEl.textContent = s.label;
      textEl.textContent  = s.text;
      blob.innerHTML      = STATUS_GLYPHS[s.icon] || STATUS_GLYPHS.check;
    }, 2400);
  }

  function wireUgcTiles(root) {
    const isTouch = matchMedia('(hover: none)').matches;
    root.querySelectorAll('.ugc-tile').forEach(function (tile) {
      const video = tile.querySelector('video');
      if (!video) return;
      if (isTouch) {
        tile.addEventListener('click', function () {
          if (video.paused) {
            video.play().catch(function () {});
          } else {
            video.pause();
          }
        });
      } else {
        tile.addEventListener('mouseenter', function () {
          video.play().catch(function () {});
        });
        tile.addEventListener('mouseleave', function () {
          video.pause();
          try { video.currentTime = 0; } catch (e) {}
        });
      }
    });
  }

  function wireFaq(root) {
    root.querySelectorAll('.faq-item').forEach(function (item) {
      const trigger = item.querySelector('.faq-q');
      if (!trigger) return;
      trigger.addEventListener('click', function () {
        const wasOpen = item.classList.contains('open');
        root.querySelectorAll('.faq-item.open').forEach(function (other) {
          other.classList.remove('open');
        });
        if (!wasOpen) item.classList.add('open');
      });
    });
  }

  function init() {
    const root = document.querySelector('.tm-home');
    if (!root) return;
    startNotifCycler(root);
    startStatusCycler(root);
    wireUgcTiles(root);
    wireFaq(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
